import _request from '@/utils/request.js'

var _purchasePlan = {
    // 提成方案列表				
    queryPlanList(query, resolve, reject) {
        _request.api({
            url: _request.getCrmUrl("/api/jcCommission/getListPage"),
            params: query,
            method: 'get',
            success: resolve,
            error: reject
        })
    },
    // 提成方案列表				
    planStateUpdate(id, state, resolve, reject) {
        _request.api({
            url: _request.getCrmUrl("/api/jcCommission/updateState"),
            params: {
                id: id,
                state: state
            },
            method: 'get',
            success: resolve,
            error: reject
        })
    },
    // 提成方案详情
    royaltyPlanDetalis(id, resolve, reject) {
        _request.api({
            url: _request.getCrmUrl("/api/jcCommission/getDetail"),
            params: {
                id: id
            },
            method: 'get',
            success: resolve,
            error: reject
        })
    },
    // 提成方案提交
    planSecondEdit(info, resolve, reject) {
        _request.api({
            url: _request.getCrmUrl("/api/jcCommission/createOrUpdate"),
            data: info,
            method: 'post',
            success: resolve,
            error: reject
        })
    },
    // 集采类型下拉列表			
    // 集采订单状态 state=JcOrderStateEnum
    // 集采类型 state=JcCategoryEnum
    // 发货状态 state=JcShippingStatusEnum
    // 配送方式 state=JcDeliveryTypeEnum	
    getcategoryList(query, resolve, reject) {
        _request.api({
            url: _request.getCrmUrl("/api/common/selectEnum"),
            params: query,
            method: 'get',
            success: resolve,
            error: reject
        })
    },	
    // 标签下拉列表 
    getTagList( resolve, reject) {
        _request.api({
            url: _request.getRegionUrl("/api/tag/getTagListByState"),
            method: 'get',
            success: resolve,
            error: reject
        })
    }
}

export default _purchasePlan